export default __webpack_public_path__ + "5268240b1f995ad9318705447766dbde.png";